import { NgClass } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { UiTSType } from "@webapp/ui/core/models/ui-type.models";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { UiTooltipModule } from "@webapp/ui/tooltip/tooltip.module";

@Component({
  selector: "help-tooltip",
  templateUrl: "./help-tooltip.component.html",
  styleUrls: ["./help-tooltip.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [UiIconModule, UiTooltipModule, NgClass],
})
export class HelpTooltipComponent {
  @Input() public content: UiTSType;
}
